import { configureStore, combineReducers } from "@reduxjs/toolkit";
import chatReducer from "./chats/chats";
import chatInfoReducer from "./chats/chatInfo";
import cannedResponsesReducer from "./chats/cannedResponses";
import chatConfigurationsReducer from "./chats/chatConfigurations";
import typingReducer from "./chats/typing";
import api from "./middlewares/api";
import socket from "./middlewares/socket";
//import socket from './middlewares/socketJSAPI';

const store = () => {
  return configureStore({
    reducer: combineReducers({
      chatReducer,
      chatInfoReducer,
      cannedResponsesReducer,
      chatConfigurationsReducer,
      typingReducer
    }),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["api/callBegan"],
          ignoredActionPaths: ["payload.resolve", "payload.reject"]
        }
      })
        .concat(api)
        .concat(socket)
  });
};

export default store;
